import type {
    ControllerProviderType } from "@rosette/royalur_react/src/game/createControllerContext.js";
import {
    createControllerContext,
    useCreateController,
} from "@rosette/royalur_react/src/game/createControllerContext.js";
import { ReactionController } from "@rosette/ts/src/business/game/controller/reactions/ReactionController.js";
import type { ReactionDirective } from "@rosette/ts/src/business/game/controller/reactions/ReactionDirective.js";


function createReactionControllerContext(): {
    ReactionControllerProvider: ControllerProviderType;
    useReactionController: () => ReactionController;
    useReactionDirective: () => ReactionDirective;
    useReactionDirectiveSelector: <V>(selector: (directive: ReactionDirective) => V) => V;
} {
    const useCreateReactionController = () => {
        return useCreateController<ReactionDirective, ReactionController>(
            () => new ReactionController(), [],
        );
    };
    const {
        ControllerProvider, useController, useDirective, useDirectiveSelector,
    } = createControllerContext<ReactionDirective, ReactionController>(useCreateReactionController);

    return {
        ReactionControllerProvider: ControllerProvider,
        useReactionController: useController,
        useReactionDirective: useDirective,
        useReactionDirectiveSelector: useDirectiveSelector,
    };
}

export const {
    ReactionControllerProvider,
    useReactionController,
    useReactionDirective,
} = createReactionControllerContext();
